import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const SENDERS = gql`
  query senders(
    $projectEnvId: ID!
    $type: ProviderType!
    $filter: SenderFilter!
  ) {
    senders(projectEnvId: $projectEnvId, type: $type, filter: $filter) {
      count
      senders {
        id
        email
        name
        phoneNo
        isVerified
        createdAt
      }
    }
  }
`;
